import axios from 'axios';
import store from '../src/store'
import state from "../src/store/state";

var getToken = () => {
    return (state.token !== undefined ? "Bearer "+state.token :"" );
};
var contentType = (type) => {
    axiosOBJ.interceptors.request.use(config => {
        config.headers['Content-Type'] = type
        return config
    })
}

var axiosOBJ = axios.create({
    headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
    }
});

var crossOrigin = (cross_origin) => {
    axiosOBJ.interceptors.request.use(config => {
        config.headers["Access-Control-Allow-Origin"] = cross_origin
        return config
    })
}

axiosOBJ.interceptors.request.use(req => {
    store.commit("TOGGLE_LOADING", true)
    req.headers.Authorization = getToken();
    return req;
});

axiosOBJ.interceptors.response.use(res => {
    store.commit("TOGGLE_LOADING", false)
    if (typeof res.data != 'string') {
        res.data.notify = {
            title: 'Success',
            text: res.data.message,
            iconPack: 'feather',
            icon: 'icon-check-square',
            color: 'success',
            position: 'top-right'
        }
    }

    return Promise.resolve(res.data);
}, error => {
    store.commit("TOGGLE_LOADING", false)
    if (error.code === "ECONNABORTED"){
        store.dispatch("AUTH_LOGOUT")
        window.location = "/login"
    }else{
        if (error.response.status == 401) {
            store.dispatch("AUTH_LOGOUT")
            window.location = "/login?redirect="+state.page
        }
    }

   /*else if (error.response.status === 500) {
        console.log(error)
    } else if (error.response.status === 400) {
        console.log(error)
    } */

    return Promise.reject(error);
})

class AxiosCall {

    static Post(payload, url) {
        contentType('application/json')
        crossOrigin('*')
        return axiosOBJ.post(url, JSON.stringify(payload));
    }

    static Put(payload, url) {
        contentType('application/json')
        return axiosOBJ.put(url, JSON.stringify(payload));
    }

    static Delete(url) {
        contentType('application/json')
        return axiosOBJ.delete(url);
    }

    static Get(payload, url) {
        contentType('application/json')
        // crossOrigin('*')
        return axiosOBJ.get(url,{params:payload})
    }

    static PostFormData(payload, url) {
        return axiosOBJ.post(url, payload, {headers: {'Content-Type': 'multipart/form-data'}})
    }

    static PutFormData(payload, url) {
        return axiosOBJ.put(url, payload, {headers: {'Content-Type': 'multipart/form-data'}})
    }

    static DownloadExcel(payload, url) {
        axios({
            url: url,
            method: 'GET',
            responseType: 'blob', // important
            data: payload
        }).then((response) => {
            const url_href = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url_href;
            link.setAttribute('download', 'file.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    }

    static DownloadCsv(url) {
        axios({
            url: url,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url_href = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url_href;
            link.setAttribute('download', 'file.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    }

    static DownloadZip(url, filename) {
        axios({
            url: url,
            method: 'GET',
            headers:{Authorization:getToken()},
            responseType: 'blob', // important
        }).then((response) => {
            // this.$vs.loading.close();
            const url_href = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url_href;
            link.setAttribute('download', filename+'.zip'); //or any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).catch(e => {
            // this.$vs.loading.close();
            console.log(e);
            swal.fire({
                type: "error",
                title: "Download File Failed!"
                //   text: "Download consolidation file"
            });
        });
    }
    static DownloadFile(url, filename) {
        axios({
            url: url,
            method: 'GET',
            // headers:{Authorization:getToken()},
            responseType: 'blob', // important
        }).then((response) => {
            // this.$vs.loading.close();
            const url_href = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url_href;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).catch(e => {

        });
    }

    static async DownloadImage(url, filename){
        let base64 = await axios
            .get(url, {
                responseType: "arraybuffer"
            })
            .then(response =>
                Buffer.from(response.data, "binary").toString("base64")
            );
        let img = new Image();
        img.src = "data:image/jpeg;base64, " + base64;
        return img;
    }

    static UploadDataForm(payload, url) {
        contentType('multipart/form-data')
        return axiosOBJ.post(url, payload)
    }
}

export default AxiosCall